import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-8" }
const _hoisted_3 = { class: "header-left-side justify-content-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20 text-decoration-none",
  type: "submit"
}, [
  /*#__PURE__*/_createTextVNode(" Research "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol position-relative ms-5 top-1" })
], -1)
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "header-right-side d-flex align-items-center justify-content-end" }
const _hoisted_10 = {
  key: 0,
  class: "dropdown notification-dropdown"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bell-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot-badge position-absolute fw-bold rounded-circle text-white bg-primary d-inline-block" }, " 3 ")
], -1)
const _hoisted_12 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_13 = { class: "title d-flex align-items-center justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Notifications "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "(03)")
], -1)
const _hoisted_15 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_16 = { class: "text-muted position-relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-target" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode("You have a new "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "Precision Pick")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_20 = { class: "text-muted position-relative" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-user-plus" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "A new user"),
  /*#__PURE__*/_createTextVNode(" added in Kapor.ai ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_24 = { class: "text-muted position-relative" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-envelope" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode(" You have new "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "inbound leads")
], -1)
const _hoisted_27 = { class: "text-center dropdown-footer" }
const _hoisted_28 = {
  key: 1,
  class: "dropdown profile-dropdown"
}
const _hoisted_29 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_30 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_31 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_32 = { class: "text-body-emphasis fw-semibold fs-13" }
const _hoisted_33 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_34 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_35 = {
  key: 0,
  class: "text-body-secondary fw-semibold transition position-relative"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-2" }, null, -1)
const _hoisted_37 = {
  key: 1,
  class: "text-body-secondary fw-semibold transition position-relative"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("li", { class: "text-body-secondary fw-semibold transition position-relative" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }),
  /*#__PURE__*/_createTextVNode(" Support "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://dbt9q0ovf1s.typeform.com/to/lweeQ2nM",
    target: "_blank",
    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
  })
], -1)
const _hoisted_40 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: _ctx.isSticky },
    ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_5),
          _createElementVNode("form", {
            class: "search-box d-none d-md-block",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            style: {"max-width":"600px"}
          }, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyName) = $event)),
                class: "form-control shadow-none rounded-0 border-0 text-black me-1",
                placeholder: "Company Name",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.companyName]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyWebsite) = $event)),
                class: "form-control shadow-none rounded-0 border-0 text-black me-1",
                placeholder: "Website",
                required: "",
                novalidate: "novalidate"
              }, null, 512), [
                [_vModelText, _ctx.companyWebsite]
              ]),
              _hoisted_7
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_LightDarkSwtichBtn),
          (_ctx.canAccessFeature('notifications'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_router_link, {
                      to: "/notifications",
                      class: "text-decoration-none link-btn transition text-primary fw-medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Clear All ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createTextVNode(" 2 hrs ago "),
                      _createVNode(_component_router_link, {
                        to: "/ai-precision-picks",
                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                      }),
                      _hoisted_19
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _hoisted_21,
                      _hoisted_22,
                      _createTextVNode(" 3 hrs ago "),
                      _createVNode(_component_router_link, {
                        to: "/",
                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                      }),
                      _hoisted_23
                    ]),
                    _createElementVNode("li", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createTextVNode(" 1 day ago "),
                      _createVNode(_component_router_link, {
                        to: "/inbound",
                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_router_link, {
                      to: "/notifications",
                      class: "link-btn text-decoration-none text-primary position-relative d-inline-block transition fw-medium fw-medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" See All Notifications ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.userProfile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("button", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, [
                      (_ctx.userData.first_name)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.userData.first_name) + " ", 1),
                            (_ctx.userData.last_name)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.userData.last_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.userData.username), 1)
                          ], 64))
                    ]),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.userProfile.is_organization_admin ? 'Admin' : _ctx.userProfile.role.charAt(0).toUpperCase() + _ctx.userProfile.role.slice(1).toLowerCase()), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("ul", _hoisted_34, [
                    (_ctx.canAccessFeature('accountSettings'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                          _hoisted_36,
                          _createTextVNode(" My Account "),
                          _createVNode(_component_router_link, {
                            to: "/account-settings",
                            class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canAccessFeature('organizationSettings'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                          _hoisted_38,
                          _createTextVNode(" Org Settings "),
                          _createVNode(_component_router_link, {
                            to: "/organization-settings",
                            class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_39,
                    _createElementVNode("li", _hoisted_40, [
                      _hoisted_41,
                      _createTextVNode(" Logout "),
                      _createVNode(_component_router_link, {
                        to: "/logout",
                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                      })
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}